import { ReactNode } from 'react'

export const PdfPages = ({ children }: { children: ReactNode }) => {
  return <div className='l-pdf-container--page-break-after-avoid'>{children}</div>
}
